import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IActionResult } from '../../../../httpClient/serverApi/types/IActionResult';

export interface IUpdateConnectionsOAuthParams {
  ids: string[];        // Data source ids
  keychainEntryId?: string;  // Id of the user keychain that should be embedded in data connections,
                             // or undefined to remove the existing embedded keychain
  usingRemoteQueryAgent?: boolean;
  // Removes the Workload Identity Federation mode from the connection, switching it to No
  // Authentication. Absent (the default) leaves the auth mode untouched, matching prior behavior.
  clearWorkgroupAuthMode?: boolean;
}

export class UpdateConnectionsOAuthRequest extends Request<IUpdateConnectionsOAuthParams, IActionResult> {
  constructor(params: IUpdateConnectionsOAuthParams) {
    super('updateConnectionsOAuth', params);
  }
}
